import { useTranslation } from '@shared/localization';

import { enableUIBlocker, PrimaryButton } from '@/components/common';
import { getQaTestingProps, QaTestingElements } from '@/utils/qaTesting';

interface PayButtonProps {
  readonly onClick: () => void;
  readonly disabled?: boolean;
  readonly title?: string;
  readonly className?: string;
}

export function PayButton({
  onClick,
  disabled = false,
  title,
  className,
}: PayButtonProps) {
  const { t } = useTranslation();

  return (
    <PrimaryButton
      disabled={disabled}
      onClick={() => {
        enableUIBlocker();
        onClick();
      }}
      {...getQaTestingProps(QaTestingElements.ContinueButton)}
      className={className}
    >
      <span className={'flex flex-row items-center justify-center'}>
        <span className={'ml-xs'}>{title ?? t('Proceed to pay')}</span>
      </span>
    </PrimaryButton>
  );
}
